// trigger instant save (see instant-save.js)
export function instantSave() {
  document.querySelectorAll(".record > form").forEach((element) => {
    element.dispatchEvent(new Event("instantSave"));
  });
}

export function getRecordIdAndType() {
  return {
    recordId: window.location.pathname.split("/").reverse()[0],
    recordType: window.location.pathname.split("/")[1],
  };
}
